<template>
  <div v-clickoutside="handleClose" class="multiple-select-container">
    <el-input
      ref="reference"
      :value="selectedLabel"
      type="text"
      clearable
      :placeholder="$t('common.pleaseSelect')"
      class="select-label-input"
      @click.native="handleArrowClick"
      @clear="clear"
    >
      <template slot="suffix">
        <i class="el-select__caret el-icon-arrow-up" :class="{'is-reverse': visible}"></i>
      </template>
    </el-input>
    <transition
      name="el-zoom-in-top"
      @after-leave="doDestroy"
    >
      <el-select-menu
        v-show="visible"
        ref="popper"
      >
        <div class="select-menu-content">
          <div class="filter-input">
            <el-input
              v-model="keywords"
              :placeholder="$t('common.pleaseEnterContent')"
              :suffix-icon="!keywords ? 'el-icon-search': ''"
              clearable
            >
            </el-input>
          </div>
          <div v-show="showOptions.length" class="scroll-area-wrap">
            <el-checkbox
              v-show="showOptions.length"
              v-model="checkAll"
              @change="handleCheckAllChange"
            >{{ $t('common.selectAll') }}</el-checkbox>
            <el-checkbox-group v-model="checkedList" @change="handleCheckedListChange">
              <div
                v-for="optionItem of showOptions"
                :key="optionItem[labelKey]"
                class="options-group"
                :class="{'normal': !complex}"
              >
                <template v-if="complex">
                  <div class="group-title">{{ optionItem[labelKey] }}</div>
                  <div v-for="item of optionItem.subSubjectList" :key="item[valueKey]">
                    <el-checkbox :label="item[valueKey]">
                      <span v-html="item[labelKey]"></span>
                    </el-checkbox>
                  </div>
                </template>
                <template v-else>
                  <el-checkbox :label="optionItem[valueKey]">
                      <span v-html="optionItem[labelKey]"></span>
                  </el-checkbox>
                </template>
              </div>
            </el-checkbox-group>
          </div>
          <div v-show="!showOptions.length" class="empty-tip">
            <img src="@/assets/remark.png" alt="" class="tip-icon-img">
            {{ $t('baseBasemultipleselect.thisOptionWasNotFound') }}
          </div>
        </div>
      </el-select-menu>
    </transition>
  </div>
</template>
<script>
import Emitter from 'element-ui/src/mixins/emitter'
import ElSelectMenu from 'element-ui/packages/select/src/select-dropdown.vue'
export default {
  name: 'BaseMultipleSelect',
  components: {
    ElSelectMenu
  },
  mixins: [Emitter],
  model: {
      prop: 'realAllCheckedIdList',
      event: 'change'
  },
  props: {
    // 默认选中的选项
    realAllCheckedIdList: {
      type: Array,
      default: () => []
    },
    // 所有的选项
    list: {
      type: Array,
      default: () => []
    },
    complex: { // 传入的optiosn数据结构是否是两层的，一层的是false,两层的是true
      type: Boolean,
      default: true
    },
    valueKey: { // 值的key
      type: String,
      default: 'code'
    },
    labelKey: { // 文本的key
      type: String,
      default: 'name'
    }
  },
  data() {
    return {
      visible: false,
      inputWidth: 0,
      keywords: '',
      checkAll: false, // 是否全选
      cashCheckedIdsList: [] // 在搜索前把之前选中的选项保存起来
    }
  },
  computed: {
    showOptions() {
      return !this.keywords ? this.options : this.filteredOptions
    },
    // 根据传进来的科目列表进行分组
    options() {
      return this.list
    },
    filteredOptions() {
      if (this.keywords) {
        let filterMethodsName = 'handleFilterOptions'
        if (!this.complex) {
          filterMethodsName = 'handleSimpleFilterOptions'
        }
        const list = this[filterMethodsName](this.options, this.keywords)
        return list
      }
      return []
    },
    // 展示的已选标签文本
    selectedLabel() {
      const { allIdToNameMap } = this.allOptionsEnum
      const allSelectedLabel = this.realAllCheckedIdList.reduce((pre, next) => {
        return `${pre && pre + '、'}` + allIdToNameMap[next]
      }, '')
      if (allSelectedLabel.length > 18) {
        return `${this.realAllCheckedIdList.length}/已选中`
      }
      return allSelectedLabel
    },
    checkedList: {
      get() {
        return this.realAllCheckedIdList
      },
      set(list) {
        this.$emit('change', [...new Set([...list, ...this.cashCheckedIdsList])])
      }
    },
    // 枚举所有的
    allOptionsEnum() {
        let methodsName = 'getAllIdsList'
        if (!this.complex) {
          methodsName = 'getFlat1AllIdsList'
        }
      return this[methodsName](this.options)
    }
  },
  watch: {
    keywords(newVal, oldValue) {
      if (!oldValue && newVal) { // 说明是从normal开始搜索, 缓存当前选中的
        this.cashCheckedIdsList = [...this.checkedList]
        this.checkedList = []
      }
    },
    visible(val) {
      if (!val) {
        // 关闭时清空data的状态
        this.broadcast('ElSelectDropdown', 'destroyPopper')
      } else {
        this.broadcast('ElSelectDropdown', 'updatePopper')
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      const reference = this.$refs.reference
      if (reference && reference.$el) {
        reference.$refs.input.setAttribute('readonly', 'readonly')
        this.inputWidth = reference.$el.getBoundingClientRect().width
      }
    })
  },
  methods: {
    // 根据关键词过滤
    handleSimpleFilterOptions(options, keywords) {
      return options.reduce((pre, next) => {
          const name = next[this.labelKey]
          if (name.includes(keywords)) {
            pre.push({
              [this.valueKey]:next[this.valueKey],
              [this.labelKey]: this.hightlightStrByKeyword(name, keywords)
            })
          }
          return pre
      }, [])
    },
    // 根据关键词过滤
    handleFilterOptions(options, keywords) {
      return options.reduce((pre, next) => {
        const filteredList = next.subSubjectList.reduce((preItem, nextItem) => {
          const name = nextItem[this.labelKey]
          if (name.includes(keywords)) {
            preItem.push({
              [this.valueKey]:nextItem[this.valueKey],
              [this.labelKey]: this.hightlightStrByKeyword(name, keywords)
            })
          }
          return preItem
        }, [])
        if (filteredList.length) {
          pre.push({
            ...next,
            subSubjectList: filteredList
          })
        }
        return pre
      }, [])
    },
    // 匹配处理高亮的文本
    hightlightStrByKeyword(str, keywords) {
      const reg = new RegExp(keywords, 'g')
      return str.replace(reg, (matchStr) => {
        return `<span class="hightlight-text">${matchStr}</span>`
      })
    },
    handleArrowClick() {
      this.visible = !this.visible
    },
    doDestroy() {
      this.$refs.popper && this.$refs.popper.doDestroy()
    },
    handleClose() {
      this.visible = false
    },
    // 全选切换
    handleCheckAllChange(isAll) {
      if (isAll) { // 全选
        if (this.keywords) {
          let methodsName = 'getAllIdsList'
        if (!this.complex) {
          methodsName = 'getFlat1AllIdsList'
        }
          this.checkedList = this[methodsName](this.showOptions).allIdsList
        } else {
          this.cashCheckedIdsList = []
          this.checkedList = this.allOptionsEnum.allIdsList
        }
      } else {
        if (this.keywords) {
          this.checkedList = []
        } else {
          this.cashCheckedIdsList = this.checkedList = []
        }
      }
    },
    // checkboxGroup切换change
    handleCheckedListChange(currentCheckedlist) {
      // 判断是否要全选
      this.checkAll = currentCheckedlist.length === this.allOptionsEnum.allIdsList.length
    },
    // 处理只有一层的集合
    getFlat1AllIdsList(options) {
      const allIdToNameMap = {}
      const allIdsList = options.reduce((pre, next) => {
          allIdToNameMap[next[this.valueKey]] = next[this.labelKey]
          pre.push(next[this.valueKey])
          return pre
      }, [])
      return {
        allIdToNameMap,
        allIdsList
      }
    },
    // 获取所有的ids集合，p-clist数据结构的数组
    getAllIdsList(options) {
      const allIdToNameMap = {}
      const allIdsList = options.reduce((pre, next) => {
        pre.push(...next.subSubjectList.reduce((preInner, nextInner) => {
          allIdToNameMap[nextInner[this.valueKey]] = nextInner[this.labelKey]
          preInner.push(nextInner[this.valueKey])
          return preInner
        }, []))
        return pre
      }, [])
      return {
        allIdToNameMap,
        allIdsList
      }
    },
    // 点击清除按钮
    clear() {
      this.checkedList = this.cashCheckedIdsList = []
      this.keywords = ''
      this.checkAll = false
    }
  }
}
</script>
<style lang="scss">
    .multiple-select-container {
        width: 210px;
        .select-label-input {
          .el-input__inner {
            cursor: pointer;
          }
        }
        .el-select__caret {
          cursor: pointer;
          line-height: 30px;
          transition: transform .3s;
          transform: rotate(180deg);
          margin-right: 4px;
          &.is-reverse {
            transform: rotate(0deg);
          }
          &:not(:only-child) {
            display: none;
          }
        }
    }
    .select-menu-content {
        padding: 12px 0 0 12px;
        .filter-input {
            padding-right: 12px;
            padding-bottom: 12px;
        }
        .scroll-area-wrap {
            width: 300px;
            max-height: 240px;
            overflow-x: hidden;
            overflow-y: auto;
            @include scrollBar;
            .el-checkbox {
              height: 32px;
              line-height: 32px;
            }
            .hightlight-text {
              color: #1F6AFF;
            }
            .options-group {
              &:not(.normal) {
                margin-top: 12px;
              }
              .group-title {
                font-size: 12px;
              }
              .el-checkbox__label {
                color: #666;
              }
              .el-checkbox__input.is-checked + .el-checkbox__label{
                color: #333;
              }
            }
        }
        .empty-tip {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          color: #666;
          padding: 41px 0;
          .tip-icon-img {
            width: 16px;
            height: 16px;
            margin-right: 4px;
          }
        }
    }
</style>
